import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, RouterLink} from "@angular/router";
import {Announcement} from "../../model/announcement";
import {ApiRequestService} from "../../services/api-request.service";
import {TimelineItem} from "../../model/timelineItem";
import {AppConfigService} from "../../app-config.service";
import {CacheService} from "../../services/cache.service";
import {format} from "date-fns";

@Component({
    selector: 'app-announcement-view',
    templateUrl: './announcement-view.component.html',
    styleUrl: './announcement-view.component.scss',
    standalone: false
})
export class AnnouncementViewComponent implements OnInit {

    public state: string = 'loading'; //not_found
    public message: string = "";

    public announcementId: number;
    public announcement: TimelineItem = null;

    private dismissAction = "dismiss";
    private acceptAction = "accept";

    constructor(
        private activatedRoute: ActivatedRoute,
        private api: ApiRequestService,
        private appConfig: AppConfigService,
        private cache: CacheService,
    ) {}
    /**
     * Component onInit. Triggers ChannelService to load channels if not loaded.
     * Initializes iframe message listener
     */
    ngOnInit(): void {
        let me = this;
        this.activatedRoute.params.subscribe({
            next: (routeParams) => {
                this.announcementId = routeParams['annc'];
                this.loadAnnouncement();
            }
        });
    }

    private loadAnnouncement() {
        let me = this;
        this.api.getAnnouncement( this.announcementId ).subscribe({
            next: (annc:any) => {
                if ( annc.id > 0) {
                    me.formatPayload(annc);
                } else {
                    me.state = 'not_found';
                    me.message = annc.message;
                }
            }
        });
    }

    private formatPayload( annc: Announcement ){
        let today = new Date();
        let pubDate = new Date( annc.startDateTime );
        let endDate = new Date( annc.expireDateTime );
        let displayDate = format( pubDate, "MMM d, h:mmaaa" );
        if ( format(today,"P") == format(pubDate,"P") ) displayDate = "Today, " + format( pubDate, "h:mmaaa");
        let item: TimelineItem = {
            collapsed: true,
            title: annc.title,
            category: annc.categoryName,
            type: String(annc.type),
            link: '',
            thumb: ( annc.attachment.length > 0 ? annc.attachment[0].url : "" ),
            pubDate: displayDate,
            endDate: format( endDate, "MMM d, h:mmaaa" ),
            endTimeStamp: endDate.getTime(),
            timestamp: pubDate.getTime(),
            body: annc.body,
            categoryCode: annc.categoryCode,
            actionLabel: annc.actionLabel,
            actionTarget: annc.actionTarget,
            actionUrl: annc.actionUrl,
            attachment: annc.bodyAttachment,
            attachments: annc.attachment,
            // contact_info: annc.contact_info,
            dismissLabel: annc.dismissLabel,
            // email_addr: annc.email_addr,
            emailLabel: annc.emailLabel,
            emailLabelId: annc.emailLabelId,
            // group_title: annc.group_title,
            // group_type: annc.group_type,
            id: annc.id,
            isSticky: annc.isStickyMessage,
            isAlert: ( annc.categoryCode == 'EMRG' ? true : false ),
            sentBy: annc.sentBy,
            sentTo: annc.sentTo,
        }
        // Filter out non-accepted images.
        if ( !this.isAcceptedImage( item.thumb ) ) {
            item.thumb = '';
        }
        // Parse content for images. Show first occurrence.
        if ( item.thumb == '' ) {
            let myRegex = /<img.*?src="(.*?)"/g;
            let results = myRegex.exec(item.body);
            if ( results != null && results.length >= 2 ) {
                if ( results[1].indexOf("announcement-stats") < 0 ) {
                    item.thumb = results[1]; //encodeURIComponent( results[1] );
                    item.thumb = item.thumb.replace(/%3A%2F%2F/g,"://").replace(/%2F/g,"/");
                    if ( !this.isAcceptedImage( item.thumb ) ) {
                        item.thumb = '';
                    }
                }
            }
        }
        // Remove height and width from img tags
        let myRegex = /(height|width)="(.*?)"/g;
        item.body = item.body.replace( myRegex, "" );
        // console.log( item );
        this.announcement = item;
    }
    /* ***************************** */

    public isSticky( item: TimelineItem ) {
        if ( item.isSticky == 1 ) return true;
        else return false;
    }

    public isAlert( item: TimelineItem ) {
        if ( item.categoryCode == 'EMRG' ) return true;
        else return false;
    }
    /**
     * Sets <article.isNews>
     * @param item
     */
    public isNews( item: TimelineItem ) {
        if ( item.type == 'news' ) return true;
        else return false;
    }
    /**
     * Sets <article.isAnnouncement>
     * @param item
     */
    public isAnnouncement( item: TimelineItem ) {
        if ( item.type == '2' ) return true;
        else return false;
    }

    /**
     * Sets <article.isBulletin>
     * @param item
     */
    public isBulletin( item: TimelineItem ) {
        if ( item.type == '1' ) return true;
        else return false;
    }
    public isUSaskNotice( item: TimelineItem ) {
        return ( item.categoryCode == 'UOFS' ) ;
    }
    public isUSaskFeatured( item: TimelineItem ) {
        return ( item.categoryCode == 'FEAT' ) ;
    }
    public isFromCentralComms( item: TimelineItem ) {
        let ids = this.appConfig.getAnnouncementLabels();
        return ( ids.indexOf( item.emailLabelId.toString() ) >= 0 )
    }
    public showActionLink( item: TimelineItem ) {
        if ( item.actionUrl != null && item.actionUrl != '' && item.actionLabel != null && item.actionLabel != '' ) return true;
        else return false;
    }
    /**
     * Accepts sticky and opens link in a new tab if there is one.
     * @param item The sticky item.
     */
    public doStickyAction( item: TimelineItem ) {
        let me = this;
        let announcementId = item.id;
        if ( item.actionUrl != '' )
            window.open( item.actionUrl );
        me.api.markAsDeletedByUserIdAndAnnouncementId(me.acceptAction,announcementId).subscribe(() => {});
        this.cache.clearCacheByName("api_feeds");

    }
    /**
     * Dismisses sticky and removes it from the announcements.
     * @param item The sticky item.
     */
    public doStickyDissmiss( item: TimelineItem ) {
        let me = this;
        let announcementId = item.id;
        me.api.markAsDeletedByUserIdAndAnnouncementId(me.dismissAction, announcementId).subscribe(() => {});
        this.cache.clearCacheByName("api_feeds");
    }
    private isAcceptedImage( url: string ): boolean {
        if ( url != null && url.length > 0 ) {
            if (url.toLowerCase().substring(url.length - 3) == 'jpg'
                || url.toLowerCase().substring(url.length - 4) == 'jpeg'
                || url.toLowerCase().substring(url.length - 3) == 'png') {
                return true;
            }
        }
        return false;
    }

}
